import React from 'react';
import { Outlet } from 'react-router-dom';

import { Box, CssBaseline } from '@mui/material';

function PrintLayout(props) {

    let {isMe} = props;
    
/********** CUSTOMIZE **********/
    const printStyles = `
        .noPrint {
            display: none !important;
        }
        @media print {
            @page {
                size: A4 landscape;
            }
        }        
    `;
/********** /CUSTOMIZE **********/

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <CssBaseline />    
            <style>{printStyles}</style>
            <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 1 }}>
                {isMe && (
                    <div style={{ margin: '0px auto 30px auto' }}>
                        <Outlet context={isMe} />
                    </div>
                )}
            </Box>
        </Box>
    );
}

export default PrintLayout;
